import React from "react";
import classnames from "classnames";
import useElements from "../hooks/useElements";
import { DropArrow } from "@wuilt/ui-components";
import {
  getLinkProps,
  MenuItemType,
  menuLinkWithSubAttrs,
} from "./ViewNavUtils";
import styles from "./NavMenu.module.scss";

function NavMenuItem(props) {
  const {
    menuItem,
    hasChildren,
    isMobile,
    className,
    isSubMenuOpen,
    onOpenSubMenu,
    onCloseSubMenu,
    navLinksColor,
  } = props;
  const {
    base: { PageLink, Link },
  }: any = useElements();

  const handleOpenSubMenu = () => {
    onOpenSubMenu(menuItem);
  };

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isSubMenuOpen) {
      onCloseSubMenu(menuItem);
      return;
    }
    onOpenSubMenu(menuItem);
  };

  const isFolder = menuItem.type_id === MenuItemType.Folder;
  const isPage = !menuItem.type_id || menuItem.type_id === MenuItemType.Page;
  const Component = isPage ? PageLink : isFolder ? "div" : Link;
  const { page, href } = getLinkProps(menuItem);

  return (
    <Component
      page={page}
      href={href}
      id="general-text"
      className={classnames(styles.menuItem, className)}
      {...(hasChildren ? menuLinkWithSubAttrs : {})}
      onMouseEnter={!isMobile ? handleOpenSubMenu : undefined}
      target={menuItem.open_in_new_tab ? "_blank" : undefined}
      onClick={isFolder && isMobile && handleToggle}
      style={{ color: navLinksColor }}
    >
      <>
        <span
          className={classnames({
            [styles.levelIndent]: isMobile && menuItem.level > 0,
          })}
          style={isMobile ? { width: 20 * menuItem.level } : {}}
        />
        <span className={styles.pageName}>
          {menuItem.name || menuItem.title}
        </span>
        {hasChildren && (
          <div
            className={classnames(styles.dropArrowContainer)}
            onClick={isMobile && handleToggle}
          >
            <DropArrow
              size="0.8em"
              className={classnames(styles.dropArrow, {
                [styles["--active"]]: isMobile && isSubMenuOpen,
              })}
            />
          </div>
        )}
      </>
    </Component>
  );
}

export default NavMenuItem;
